import { TComplimentaryProductInfo, TState } from 'pages/dimensions/store/dimensions';

type TGetNewCountValue = {
  prevState: TState;
  newValue: number;
  product: TComplimentaryProductInfo;
};

export const addNewCountValue = ({ prevState, newValue, product }: TGetNewCountValue) =>
  prevState.complimentaryProductInfo.map(item =>
    item.productId === product.productId
      ? {
          ...product,
          total: {
            ...item.total,
            requiredQuantity: newValue,
          },
        }
      : item
  );
